import React from 'react';
import styles from './ADSCredit.module.scss'
import {useADSContext} from "../../context/ADSProvider";
import Skeleton from "@mui/material/Skeleton";

const ADSCredit = () => {
  const {userInfo, loadingUserInfo} = useADSContext();

  const {balance, creditSpent} = userInfo.userCredit || {};
  const isEmptyBalance = balance === 0;

  if (loadingUserInfo) {
    return (
      <Skeleton variant="rounded" width={180} height={40} sx={{marginBottom: '24px', borderRadius: '15px'}} />
    )
  }

  return (
    <div className={styles.wrapper}>
      <span className={styles.itemLeft}>
        {balance} Credits available
      </span>

      <span className={`${styles.itemRight} ${isEmptyBalance ? styles.allUsed : ''}`}>
        {creditSpent} used
      </span>
    </div>
  );
};

export default ADSCredit;
